import api from '../../../services/api'
import buildQuery from 'odata-query'

const ICONS_URL = '/imagestore'

export function getIcons ( queryParams ) {
    return api.get(`${ICONS_URL}/odata${buildQuery(queryParams)}`)
}

export function createIcon ( data ) {
    return api.post(`${ICONS_URL}`, data)
}

export function deleteIcon ( id ) {
    return api.delete(`${ICONS_URL}/${id}`, {
        id: id
    })
}

export function updateIcon ( iconData ) {
    return api.put(`${ICONS_URL}`, iconData )
}